(function () {
  var consent = window.StogglesConsent;
  var banner = document.querySelector('[data-consent-banner]');
  if (!consent || !banner) return;

  var prefs = banner.querySelector('[data-consent-prefs]');
  var buttons = {};
  banner.querySelectorAll('[data-consent-action]').forEach(function (button) {
    buttons[button.getAttribute('data-consent-action')] = button;
  });

  function withPrivacyApi(callback) {
    var shopify = window.Shopify;
    if (!shopify) return;
    if (shopify.customerPrivacy && shopify.customerPrivacy.setTrackingConsent) return callback(shopify.customerPrivacy);
    if (!shopify.loadFeatures) return;
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error && shopify.customerPrivacy) callback(shopify.customerPrivacy);
    });
  }

  function visitorConsent(privacy) {
    return (privacy.currentVisitorConsent && privacy.currentVisitorConsent()) || {};
  }

  function decided(current) {
    return ['analytics', 'marketing', 'preferences', 'sale_of_data'].some(function (key) {
      return current[key] === 'yes' || current[key] === 'no';
    });
  }

  function fromShopify(current, base) {
    function pick(value, fallback) {
      return value === 'yes' ? true : value === 'no' ? false : !!fallback;
    }
    return {
      analytics: pick(current.analytics, base.analytics),
      marketing: pick(current.marketing, base.marketing) && current.sale_of_data !== 'no',
      preferences: pick(current.preferences, base.preferences)
    };
  }

  function same(a, b) {
    return consent.categories.every(function (cat) { return !!a[cat] === !!b[cat]; });
  }

  function pushToShopify(privacy, state) {
    var current = visitorConsent(privacy);
    var wanted = {
      analytics: !!state.analytics,
      marketing: !!state.marketing,
      preferences: !!state.preferences,
      sale_of_data: !!state.marketing
    };
    var inSync = Object.keys(wanted).every(function (key) {
      return current[key] === (wanted[key] ? 'yes' : 'no');
    });
    if (!inSync) privacy.setTrackingConsent(wanted, function () {});
  }

  function reconcile(privacy) {
    reconcileState(privacy);
    refreshInline();
  }

  function reconcileState(privacy) {
    var current = visitorConsent(privacy);
    var stored = consent.get();
    if (stored) {
      if (decided(current)) {
        var shopify = fromShopify(current, stored);
        var strictest = {};
        consent.categories.forEach(function (cat) { strictest[cat] = !!stored[cat] && !!shopify[cat]; });
        if (!same(strictest, stored)) consent.set(strictest);
      }
      pushToShopify(privacy, consent.get());
      return;
    }
    if (decided(current)) {
      consent.set(fromShopify(current, consent.current() || {}));
      return;
    }
    if (consent.required) {
      if (!(privacy.shouldShowBanner && privacy.shouldShowBanner())) open(false, false);
      return;
    }
    if (consent.gpc) privacy.setTrackingConsent({ marketing: false, sale_of_data: false }, function () {});
  }

  function fill(container) {
    var state = consent.current() || {};
    consent.categories.forEach(function (cat) {
      var input = container.querySelector('[name="' + cat + '"]');
      if (input) input.checked = !!state[cat];
    });
  }

  function read(container) {
    var state = {};
    consent.categories.forEach(function (cat) {
      var input = container.querySelector('[name="' + cat + '"]');
      state[cat] = !!(input && input.checked);
    });
    return state;
  }

  var inlineForms = Array.prototype.slice.call(document.querySelectorAll('[data-consent-inline]'));

  function refreshInline() {
    inlineForms.forEach(fill);
  }

  function showPrefs(show) {
    prefs.hidden = !show;
    buttons.customize.hidden = show;
    buttons.save.hidden = !show;
    if (show) fill(prefs);
  }

  function open(withPrefs, focus) {
    showPrefs(!!withPrefs);
    banner.hidden = false;
    if (focus) banner.querySelector(withPrefs ? '.consent-banner__switch' : '.consent-banner__button').focus();
  }

  function close() {
    banner.hidden = true;
    showPrefs(false);
  }

  function choose(state) {
    consent.set(state);
    withPrivacyApi(function (privacy) { pushToShopify(privacy, consent.get()); });
    close();
  }

  function all(value) {
    var state = {};
    consent.categories.forEach(function (cat) { state[cat] = value; });
    return state;
  }

  buttons.accept.addEventListener('click', function () { choose(all(true)); });
  buttons.reject.addEventListener('click', function () { choose(all(false)); });
  buttons.customize.addEventListener('click', function () { showPrefs(true); });
  buttons.save.addEventListener('click', function () { choose(read(prefs)); });

  inlineForms.forEach(function (form) {
    var status = form.querySelector('[data-consent-status]');
    var gpcNote = form.querySelector('[data-consent-gpc]');
    if (gpcNote) gpcNote.hidden = !consent.gpc;
    fill(form);
    try {
      if (status && sessionStorage.getItem('stg_consent_saved')) status.textContent = status.getAttribute('data-saved');
      sessionStorage.removeItem('stg_consent_saved');
    } catch (e) {}
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var next = read(form);
      var current = consent.current() || {};
      var revoking = consent.categories.some(function (cat) { return current[cat] && !next[cat]; });
      if (revoking) {
        try { sessionStorage.setItem('stg_consent_saved', '1'); } catch (e) {}
      }
      choose(next);
      refreshInline();
      if (status) status.textContent = status.getAttribute('data-saved');
    });
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-consent-open], a[href$="#privacy-choices"]');
    if (!trigger) return;
    event.preventDefault();
    open(true, true);
  });

  banner.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && consent.get()) close();
  });

  document.addEventListener('visitorConsentCollected', function (event) {
    withPrivacyApi(function (privacy) {
      if (!decided(visitorConsent(privacy))) return;
      var detail = event.detail || {};
      var next = {
        analytics: detail.analyticsAllowed === true,
        marketing: detail.marketingAllowed === true && detail.saleOfDataAllowed !== false,
        preferences: detail.preferencesAllowed === true
      };
      if (consent.get() && same(consent.current(), next)) return;
      consent.set(next);
      close();
      refreshInline();
    });
  });

  var reconciled = false;
  withPrivacyApi(function (privacy) {
    reconciled = true;
    reconcile(privacy);
  });

  if (consent.required && !consent.get()) {
    setTimeout(function () {
      if (!reconciled && !consent.get()) open(false, false);
    }, 4000);
  }
})();
